import { render } from "./HelpBtn.vue?vue&type=template&id=1168add7"
import script from "./HelpBtn.vue?vue&type=script&lang=js"
export * from "./HelpBtn.vue?vue&type=script&lang=js"

import "./HelpBtn.vue?vue&type=style&index=0&id=1168add7&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__